import { isObject } from 'lodash';
import { types as layoutTypes } from './layout';
import svc from 'svc';



export const types = {
	SET_STATE: 'PAYMENTS/SET_STATE',
	RESET_ALL: 'PAYMENTS/RESET_ALL',
	RESET_CARD: 'PAYMENTS/RESET_CARD',
	RESET_PROPERTY: 'PAYMENTS/RESET_PROPERTY',
};

/* LINE SAMPLE
	Item: '1095AF-02', //*
	Key: 0,
	Qty: 1, //*
	UnitPrice: 133.7, //*
	Price: 13.37, //*
	PriceAfterVat: 133.7, //*
	TaxCode: 'EX', //*
	//...Optional...
	Description: 'Its cool',
	DiscountByPercent: 5
 */

export const initialState = {
	availableCards: [],
	requestPending: false,
	exitingMethodsPending: false,
	selectedCard: '',
	cardCode: null,
	docType: null,
	docRef: null,
	existingMethods: [],
	card: {
		number: '',
		name: '',
		firstName: '',
		lastName: '',
		expireMonth: '01',
		expireYear: new Date().getFullYear().toString(),
		expiry: '',
		cvc: '',
		zip: '',
		focused: '',
		cardType: '',
		isValid: true,
		cardLength: 16,
		billToRef: '',
		shipToRef: '',
		amount: 0,
		saveCard: false,
	},
};


export default ( state = initialState, action ) => {
	switch (action.type) {
		case types.SET_STATE:
			return { ...state, ...action.data };
		case types.RESET_ALL:
			return { ...initialState };
		case types.RESET_CARD:
			return { ...state, card: { ...initialState.card } };
		case types.RESET_PROPERTY:
			return resetProperty( state, action );
		default:
			return state;
	}
}


export const actions = {
	setState: ( data ) => ({ type: types.SET_STATE, data }),
	resetAll: () => ({ type: types.RESET_ALL }),
	resetCard: () => ({ type: types.RESET_CARD }),
	resetProperty: ( property ) => ({ type: types.RESET_PROPERTY, property }),


	getExistingCards: ( cardCode ) => {
		return ( dispatch, getState ) => {
			dispatch( { type: types.SET_STATE, data: { existingMethodsPending: true } } );

			svc.send( 'payflow', { method: 'listSavedCards', cardCode: cardCode } ).then( res => {
				dispatch( {
					type: types.SET_STATE, data: {
						existingMethodsPending: false,
						existingMethods: res.payload.data,
					},
				} );
			} ).catch( err => {
				dispatch( { type: layoutTypes.NOTIFY, text: err.msg, duration: 5000 } );
				dispatch( { type: types.SET_STATE, data: { existingMethodsPending: false } } );
			} );
		};
	},

	saveCustomer: ( cardCode, extras = {}, successCallback = null, failureCallback = null ) => {
		/*
		 * When provided, callbacks run on resolve or reject of save payment promise.
		 * An object with three properties will be passed to the callback:
		 *     { successful: boolean, tsCode: TSPAYFLOW.Code, authCode: (PayFlow auth code) }
		 */

		return ( dispatch, getState ) => {
			if ( !cardCode ) {
				dispatch( { type: layoutTypes.NOTIFY, text: 'Must provide cardcode to save card.', duration: 5000 } );
				return false;
			}

			let state = getState();
			let details = formatCardData( state.payments, cardCode );
			dispatch( { type: types.SET_STATE, data: { requestPending: true } } );

			svc.send( 'payflow', {
				method: 'saveCustomer',
				...details,
				extras,
			} ).then( res => {
				dispatch( { type: types.SET_STATE, data: { requestPending: false } } );
				dispatch( { type: layoutTypes.NOTIFY, text: 'Card saved successfully!', duration: 5000 } );

				if ( typeof successCallback === 'function' ) {
					successCallback( res.payload );
				}
			} ).catch( err => {
				dispatch( { type: types.SET_STATE, data: { requestPending: false } } );
				dispatch( { type: layoutTypes.NOTIFY, text: err.msg, duration: 6000 } );

				if ( typeof failureCallback === 'function' ) {
					failureCallback( err );
				}
			} );

		};
	},


	authorizeCard: ( cardCode, amount, extras = {}, successCallback = null, failureCallback = null ) => {
		/*
		 * When provided, callbacks run on resolve or reject of save payment promise.
		 * An object with three properties will be passed to the callback:
		 *     { successful: boolean, tsCode: TSPAYFLOW.Code, authCode: (PayFlow auth code) }
		 */

		return ( dispatch, getState ) => {
			if ( !cardCode ) {
				dispatch( { type: layoutTypes.NOTIFY, text: 'Must provide cardcode to save card.', duration: 5000 } );
				return false;
			}

			let state = getState();
			let details = formatCardData( state.payments, cardCode );
			dispatch( { type: types.SET_STATE, data: { requestPending: true } } );

			svc.send( 'payflow', {
				method: 'authorizeCard',
				...details,
				extras,
				amount,
			} ).then( res => {
				dispatch( { type: types.SET_STATE, data: { requestPending: false } } );
				dispatch( { type: layoutTypes.NOTIFY, text: 'Card authorized successfully!', duration: 5000 } );

				if ( typeof successCallback === 'function' ) {
					successCallback( res.payload );
				}
			} ).catch( err => {
				dispatch( { type: types.SET_STATE, data: { requestPending: false } } );
				dispatch( { type: layoutTypes.NOTIFY, text: err.msg, duration: 6000 } );

				if ( typeof failureCallback === 'function' ) {
					failureCallback( err );
				}
			} );

		};
	},


	chargeCard: ( cardCode, amount, extras = {}, successCallback = null, failureCallback = null ) => {
		/*
		 * When provided, callbacks run on resolve or reject of save payment promise.
		 * An object with three properties will be passed to the callback:
		 *     { successful: boolean, tsCode: TSPAYFLOW.Code, authCode: (PayFlow auth code) }
		 */

		return ( dispatch, getState ) => {
			if ( !cardCode ) {
				dispatch( { type: layoutTypes.NOTIFY, text: 'Must provide cardcode to save card.', duration: 5000 } );
				return false;
			}

			let state = getState();
			let details = formatCardData( state.payments, cardCode );
			dispatch( { type: types.SET_STATE, data: { requestPending: true } } );

			svc.send( 'payflow', {
				method: 'chargeCard',
				...details,
				extras,
				amount,
			} ).then( res => {
				dispatch( { type: types.SET_STATE, data: { requestPending: false } } );
				dispatch( { type: layoutTypes.NOTIFY, text: 'Card charged successfully!', duration: 5000 } );

				if ( typeof successCallback === 'function' ) {
					successCallback( res.payload );
				}
			} ).catch( err => {
				dispatch( { type: types.SET_STATE, data: { requestPending: false } } );
				dispatch( { type: layoutTypes.NOTIFY, text: err.msg, duration: 6000 } );

				if ( typeof failureCallback === 'function' ) {
					failureCallback( err );
				}
			} );

		};
	},


	referenceAuthorization: ( cardCode, refCode, amount, extras = {}, successCallback = null, failureCallback = null ) => {
		/*
		 * When provided, callbacks run on resolve or reject of save payment promise.
		 * An object with three properties will be passed to the callback:
		 *     { successful: boolean, tsCode: TSPAYFLOW.Code, authCode: (PayFlow auth code) }
		 */

		return ( dispatch, getState ) => {
			//let state   = getState();

			if ( !cardCode ) {
				dispatch( {
					type: layoutTypes.NOTIFY,
					text: 'Must provide cardcode to authorize payment.',
					duration: 5000,
				} );
				return false;
			}
			if ( !refCode ) {
				dispatch( {
					type: layoutTypes.NOTIFY,
					text: 'Must provide card reference to authorize payment.',
					duration: 5000,
				} );
				return false;
			}

			dispatch( { type: types.SET_STATE, data: { requestPending: true } } );

			return svc.send( 'payflow', {
				method: 'referenceAuthorization',
				shipTo: {},
				cardCode,
				refCode,
				amount,
				extras,
			} ).then( res => {
				dispatch( { type: types.SET_STATE, data: { requestPending: false } } );
				dispatch( { type: layoutTypes.NOTIFY, text: 'Card authorized successfully!', duration: 5000 } );

				if ( typeof successCallback === 'function' ) {
					successCallback( res.payload );
				}
				return res;
			} ).catch( err => {
				dispatch( { type: types.SET_STATE, data: { requestPending: false } } );
				dispatch( { type: layoutTypes.NOTIFY, text: err.msg, duration: 6000 } );

				if ( typeof failureCallback === 'function' ) {
					failureCallback( err );
				}
				throw err;
			} );

		};

	},



	referencePayment: ( cardCode, refCode, amount, extras = {}, successCallback = null, failureCallback = null ) => {
		/*
		 * When provided, callbacks run on resolve or reject of save payment promise.
		 * An object with three properties will be passed to the callback:
		 *     { successful: boolean, tsCode: TSPAYFLOW.Code, authCode: (PayFlow auth code) }
		 */

		return ( dispatch, getState ) => {
			;
			//let state   = getState();

			if ( !cardCode ) {
				dispatch( {
					type: layoutTypes.NOTIFY,
					text: 'Must provide cardcode to charge payment.',
					duration: 5000,
				} );
				return false;
			}
			if ( !refCode ) {
				dispatch( {
					type: layoutTypes.NOTIFY,
					text: 'Must provide card reference to charge payment.',
					duration: 5000,
				} );
				return false;
			}
			dispatch( { type: types.SET_STATE, data: { requestPending: true } } );

			return svc.send( 'payflow', {
				method: 'referencePayment',
				shipTo: {},
				cardCode,
				refCode,
				amount,
				extras,
			} ).then( res => {
				dispatch( { type: types.SET_STATE, data: { requestPending: false } } );
				dispatch( { type: layoutTypes.NOTIFY, text: 'Card charged successfully!', duration: 5000 } );

				if ( typeof successCallback === 'function' ) {
					successCallback( res.payload );
				}
				return res;
			} ).catch( err => {
				dispatch( { type: types.SET_STATE, data: { requestPending: false } } );
				dispatch( { type: layoutTypes.NOTIFY, text: err.msg, duration: 6000 } );

				if ( typeof failureCallback === 'function' ) {
					failureCallback( err );
				}
				throw err;
			} );

		};

	},



	delayedCapture: ( cardCode, refCode, amount, extras = {}, successCallback = null, failureCallback = null ) => {
		/*
		 * When provided, callbacks run on resolve or reject of save payment promise.
		 * An object with three properties will be passed to the callback:
		 *     { successful: boolean, tsCode: TSPAYFLOW.Code, authCode: (PayFlow auth code) }
		 */

		return ( dispatch, getState ) => {
			//let state   = getState();

			if ( !cardCode ) {
				dispatch( {
					type: layoutTypes.NOTIFY,
					text: 'Must provide cardcode to authorize payment.',
					duration: 5000,
				} );
				return false;
			}
			if ( !refCode ) {
				dispatch( {
					type: layoutTypes.NOTIFY,
					text: 'Must provide card reference to authorize payment.',
					duration: 5000,
				} );
				return false;
			}

			dispatch( { type: types.SET_STATE, data: { requestPending: true } } );

			svc.send( 'payflow', {
				method: 'delayedCapture',
				cardCode,
				refCode,
				amount,
				extras,
			} ).then( res => {
				dispatch( { type: types.SET_STATE, data: { requestPending: false } } );
				dispatch( { type: layoutTypes.NOTIFY, text: 'Funds captured successfully!', duration: 5000 } );

				if ( typeof successCallback === 'function' ) {
					successCallback( res.payload );
				}
			} ).catch( err => {
				dispatch( { type: types.SET_STATE, data: { requestPending: false } } );
				dispatch( { type: layoutTypes.NOTIFY, text: err.msg, duration: 6000 } );

				if ( typeof failureCallback === 'function' ) {
					failureCallback( err );
				}
			} );

		};

	},

};

function resetProperty( state, action ) {
	if ( initialState.hasOwnProperty( action.property ) && isObject( initialState[ action.property ] ) ) {
		return { ...state, [ action.property ]: { ...initialState[ action.property ] } };
	}

	return state;
}



function formatCardData( state, cardCode ) {
	let payment = state.card;
	/*
	let billIndex = findIndex(state.addresses.billing, {ID: payment.billToRef});
	let shipIndex = findIndex(state.addresses.shipping, {ID: payment.shipToRef});
	let billAddress = billIndex === -1 ? {} : state.addresses.billing[billIndex];
	let shipAddress = shipIndex === -1 ? {} : state.addresses.shipping[shipIndex];
	*/
	let expYear = payment.expireYear.toString();

	let cc = {
		creditCardNumber: payment.number,
		expirationMonth: payment.expireMonth,
		expirationYear: expYear.substr( expYear.length - 2 ),
		cvv: payment.cvc,
	};

	let billTo = {};

	let shipTo = {};

	let customer = {
		customerFirstName: payment.firstName,
		customerLastName: payment.lastName,
	};

	return {
		customer,
		shipTo,
		billTo,
		cc,
		cardCode: cardCode,
		ccType: payment.cardType,
		amount: payment.amount,
	};
}